"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.interval = exports.retry = void 0;
const milliseconds_1 = require("./milliseconds");
const utils_1 = require("./utils");
const logging_1 = require("./logging");
function retry(fn, retryWait = (0, utils_1.randomInRange)(milliseconds_1.$4seconds, milliseconds_1.$6seconds), maxAttempts = 3) {
    return __awaiter(this, void 0, void 0, function* () {
        let attempts = 0;
        let lastError;
        while (attempts++ < maxAttempts) {
            try {
                return yield fn();
            }
            catch (err) {
                lastError = err;
                (0, logging_1.logWarning)(`Function failed to execute. Retrying... (${attempts})`, (err === null || err === void 0 ? void 0 : err.stack) || err);
                yield (0, utils_1.wait)(retryWait);
            }
        }
        if (lastError)
            throw lastError;
    });
}
exports.retry = retry;
function interval(fn, time = milliseconds_1.$5minutes, immediate = true) {
    if (immediate)
        fn();
    return setInterval(fn, time);
}
exports.interval = interval;
function delay(fn, time = (0, utils_1.randomInRange)(milliseconds_1.$1second, milliseconds_1.$10seconds)) {
    return setTimeout(fn, time);
}
exports.delay = delay;
